export type AuthOptionType =
  | 'oauth_google'
  | 'oauth_microsoft'
  | 'password'
  | 'saml';

export const AUTH_OPTION_TYPES = {
  OAUTH_GOOGLE: 'oauth_google' as const,
  OAUTH_MICROSOFT: 'oauth_microsoft' as const,
  PASSWORD: 'password' as const,
  SAML: 'saml' as const,
} as const;

export interface AuthLoginMethod {
  type: AuthOptionType;
  label: string;
}

export interface GetAuthOptionsResponse {
  email: string;
  login_methods: AuthLoginMethod[];
}

/**
 * Helper function to check if a login method type is an OAuth provider
 */
export const isOAuthProvider = (type: AuthOptionType): boolean => {
  return (
    type === AUTH_OPTION_TYPES.OAUTH_GOOGLE ||
    type === AUTH_OPTION_TYPES.OAUTH_MICROSOFT
  );
};
